<template>
  <Content @back="['admin'].includes(userRole) ? $router.push('/home/index?details=mans') : $router.push('/home')">
    <template v-slot:nav_left>区体育行政部门管理</template>
    <template v-slot:nav_right>
      <div v-if="userRole === 'system'" class="yioks_btn" @click="addOrg = true">
        添加区体育行政部门
      </div>
    </template>
    <template v-slot:content_left="countNum">
      <p>{{$t('allCoaches')}} : {{countNum.countNum.coachNum}}</p>
    </template>
    <template v-slot:content_right>
      <div class="select_wrap">
        <div class="select_box">
          <!-- <select v-model="selectVal.provinceCode" class="yioks_select" @change="changeProvince()" >
            <option value=''>全部省份</option>
            <option
              v-for="item in selectRegions"
              :key="item.code"
              :value="item.code"
            >{{ item.name }}</option>
          </select> -->
          <select v-model="selectVal.cityCode" class="yioks_select" @change="changeCity(true)" >
            <option value=''>全部城市</option>
            <option
              v-for="item in select_city_list"
              :key="item.code"
              :value="item.code"
            >{{ item.name }}</option>
            <!-- selectCityList -->
          </select>
          <select v-model="selectVal.countyCode" class="yioks_select" @change="changeCountyForCoachList" >
            <option value=''>全部区</option>
            <option
              v-for="item in select_county_list"
              :key="item.code"
              :value="item.code"
            >{{ item.name }}</option>
            <!-- selectCityList -->
          </select>
        </div>
        <div class="search_box">
          <input
            v-model.trim="selectVal.keyWord"
            type="text"
            class="yioks_input"
            placeholder="请输入关键词"
            @keyup.enter="changeQuery(true)"
          >
          <div class="yioks_btn" @click="changeQuery(true)">{{$t('search')}}</div>
        </div>
      </div>
      <div class="list_wrap">
        <div v-if="showList" class="table">
          <div class="thead">
            <div class="tr">
              <div class="th seq"><strong>序号</strong></div>
              <div class="th name"><strong>区体育行政部门名称</strong></div>
              <div class="th idName"><strong>管理员姓名</strong></div>
              <!-- <div class="th province"><strong>省份</strong></div> -->
              <div class="th city"><strong>城市</strong></div>
              <div class="th county"><strong>区</strong></div>
              <div class="th status"><strong>状态</strong></div>
              <div class="th opt"><strong>操作</strong></div>
            </div>
          </div>
          <div class="scrollArea">
            <vue-scroll >
              <div class="tbodyWrap">
                <div class="tbody">
                  <div
                    v-for="(item, index) in orgList"
                    :key="index"
                    class="tr">
                    <div class="td seq">
                      <p>{{ index + 1 }}</p>
                    </div>
                    <div class="td name">
                      <p>{{ item.organShortName || '--' }}</p>
                    </div>
                    <div class="td idName">
                      <p>{{item.organUserName}}</p>
                    </div>
                    <!-- <div class="td province">
                      <p>{{item.provinceName}}</p>
                    </div> -->
                    <div class="td city">
                      <p>{{ item.cityName || '--'}}</p>
                    </div>
                    <div class="td county">
                      <p>{{ item.countyName || '--'}}</p>
                    </div>
                    <div class="td status">
                      <p>{{ item.status | statusFilter }}</p>
                    </div>
                    <div class="td opt">
                      <p>
                        <span class="item" @click="goInfo(item.uuid)">查看</span>
                        <template v-if="userRole === 'system'">
                          <span class="split">/</span>
                          <span class="item" @click="editOrg(item.uuid)">编辑</span>
                        </template>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
        <yioks-loading v-if="loading" />
        <yioks-empty v-if="empty" />
      </div>
      <Pagination :total="total" :pageSize="pageSize" :page.sync="page"/>
      <el-dialog
        :visible.sync="addOrg"
        width="600px"
        :title="isEdit? '编辑区体育行政部门' : '添加区体育行政部门'"
        :close-on-click-modal="false"
        :top="isEdit ? '10vh' : '13vh'"
        custom-class="yioks_alert"
      >
        <el-form
          ref="orgInfo"
          :model="orgInfo"
          :rules="formRules"
          label-width="180px"
          style="height: 490px"
          class="demo-ruleForm">
          <vue-scroll :ops='ops'>
            <el-row>
              <el-form-item label="区体育行政部门级别" prop="organType">
                <el-radio-group v-model="orgInfo.organType" :disabled="isEdit" @change="changeType">
                  <!-- <el-radio label="PROVINCE">省级</el-radio> -->
                  <el-radio label="CITY">市级</el-radio>
                  <el-radio label="COUNTY">区级</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-row>
            <el-row class="provinceOrg" >
              <div class="label">区体育行政部门所属区域</div>
              <!-- <el-col :span="7">
                <el-form-item  label-width="0" prop="provinceCode">
                  <el-select v-model="orgInfo.provinceCode" placeholder="请选择省">
                    <el-option
                      v-for="item in regions"
                      :key="item.code"
                      :value="item.code"
                      :label="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <el-col :span="6" >
                <el-form-item  label-width="0" prop="cityCode">
                  <el-select class="w_select"
                    v-model="orgInfo.cityCode"
                    placeholder="请选择市"
                    clearable
                    @change="changeCityForOrg" >
                    <el-option
                      v-for="item in select_city_list"
                      :key="item.code"
                      :value="item.code"
                      :label="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col v-if="orgInfo.organType==='COUNTY'" :span="6" :offset="1">
                <el-form-item  label-width="0" prop="countyCode">
                  <el-select class="w_select"
                    v-model="orgInfo.countyCode"
                    placeholder="请选择区"
                    @change="changeCountyForAddCoach"
                    clearable
                    >
                    <el-option
                      v-for="item in sh_county_list"
                      :key="item.code"
                      :value="item.code"
                      :label="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="区体育行政部门全称" prop="organName">
                  <el-input v-model.trim="orgInfo.organName" :disabled="isEdit" placeholder="请输入区体育行政部门名称(50个字以内)"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="区体育行政部门简称" prop="organShortName">
                  <el-input v-model.trim="orgInfo.organShortName" :disabled="isEdit" placeholder="请输入区体育行政部门简称(20个字以内)"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="管理员姓名" prop="idName">
                  <el-input v-model.trim="orgInfo.idName" placeholder="请输入区体育行政部门管理员姓名"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item v-if="isEdit" label="区体育行政部门用户名">
                  <el-input v-model.trim="orgInfo.loginName" :disabled="isEdit" placeholder="请输入用户名(以2-5位的字母组成并拼上制定格式组成)"></el-input>
                </el-form-item>
                <el-form-item v-else label="用户名" prop="loginName">
                  <el-input v-model.trim="orgInfo.loginName" placeholder="请输入用户名(以2-5位的字母组成并拼上制定格式组成)" style="width: 60%"></el-input><span style="color: red; padding-left: 10px;font-size: 20px;">admin</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="管理员手机号" prop="phone">
                  <el-input v-model.trim="orgInfo.phone" placeholder="请输入区体育行政部门管理员手机号"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="isEdit">
              <el-col :span="20">
                <el-form-item label="区体育行政部门状态" prop="status">
                  <el-select v-model.trim="orgInfo.status" style="width: 100%">
                    <el-option
                      v-for="(item, index) in centerStatusList"
                      :key="index"
                      :label="item.name"
                      :value="item.status"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="isEdit">
              <el-col :span="20">
                <el-form-item label="密码" prop="password">
                  <el-input v-model.trim="orgInfo.password" placeholder="请输入将要更改的密码" type="password"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="20">
                <el-form-item label="确认密码" prop="confirmPassword">
                  <el-input  v-model.trim="orgInfo.confirmPassword" placeholder="请输入确认密码" type="password"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="isEdit">
              <el-col :span="21">
                <el-form-item label="上传logo">
                  <UploadImg :imgUrl.sync='orgInfo.banner ' :errImg="memberImg" :avatarUrl.sync="img" />
                  <div>支持jpg,jpeg,bmp,gif,png格式上传</div>
                </el-form-item>
              </el-col>
            </el-row>
          </vue-scroll>
        </el-form>
        <div v-if="!isEdit" class="tip">* 用户名将作为登录帐号，手机号作为登录的初始密码。</div>
        <div class="dialog_btn_wrap">
          <el-button
            type="primary"
            style="margin-right:20px"
            :loading="addbtnLoading"
            @click="addOrgan"
          >{{$t('confirm')}}</el-button>
          <el-button type="danger" @click="addOrg = false">{{$t('cancel')}}</el-button>
        </div>
      </el-dialog>
    </template>
  </Content>
</template>

<script>

import 'vue-awesome/icons/regular/edit'
import org from '@/api/org'
import memberImg from '@/assets/images/common/member.png'
import regions from '@/utils/regions'
// import { JSEncrypt } from 'jsencrypt'
import JSEncrypt from '@/assets/js/jsencrypt.min.js'
import auth from '@/api/auth'
import rulesMixin from '@/utils/formRules/org'
import { centerStatusList } from '@/utils/yioks_data'
import { centerStatus } from '@/utils/yioks_filter'
import { ops } from '@/utils/scrollIndialog'
import mixinAddressForSH from '@/mixin/mixinAddressForSH';
import storage from '@/utils/storage'

export default {
  components: {
    'Content': () => import('@/components/layout/list'),
    'Pagination': () => import('@/components/Pagination'),
    'UploadImg': () => import('@/components/UploadImg')
    // 'UploadFile': () => import('@/components/UploadFile')
  },
  filters: {
    statusFilter (val) {
      return centerStatus(val)
    }
  },
  mixins: [rulesMixin, mixinAddressForSH],
  data () {
    return {
      userRole: storage.get('userInfo').userRole,
      ops,
      img: '',
      regions,
      selectRegions: regions,
      selectCityList: [],
      addAssociation: false,
      selectVal: {
        keyWord: '',
        cityCode: '',
        countyCode: '',
        provinceCode: ''
      },
      total: 0,
      page: 0,
      pageSize: 20,
      empty: false,
      showList: false,
      memberImg,
      addOrg: false,
      orgInfo: {
        idName: '',
        loginName: '',
        organType: '',
        organName: '',
        organShortName: '',
        provinceCode: '31',
        provinceName: '上海市',
        cityCode: '',
        cityName: '',
        countyCode: '',
        countyName: '',
        phone: '',
        status: '',
        password: '',
        confirmPassword: '',
        banner: ''
      },
      loading: true,
      cityList: [],
      addbtnLoading: false,
      isEdit: false,
      centerStatusList,
      organList: [{ label: '中国足协', value: 'china' }, { label: '河南足协', value: 'Henan' }], // 机构列表
      centerList: [], // 青训中心列表,
      orgList: [], // 区体育行政部门列表
      editIng: false
    }
  },
  watch: {
    // 对 dialog 的显示隐藏监听，重置数据
    addOrg (val) {
      if (!val) {
        // 数据清空
        this.editIng = false
        this.orgInfo = {
          idName: '',
          loginName: '',
          organType: '',
          organName: '',
          organShortName: '',
          // provinceCode: '',
          // provinceName: '',
          cityCode: '',
          cityName: '',
          countyCode: '',
          countyName: '',
          phone: '',
          status: '',
          password: '',
          confirmPasswordL: '',
          banner: ''
        }
        // 表单的验证规则
        this.$refs['orgInfo'].resetFields()
        // 清楚是否编辑
        this.isEdit = false
      }
    },
    page () {
      this.changeQuery()
    },
    // 'orgInfo.provinceCode': {
    //   handler (val) {
    //     this.regions.forEach(item => {
    //       if (item.code === val) {
    //         // this.orgInfo.cityCode = this.cityList[0].code
    //         if (this.orgInfo.organType === 'CITY') {
    //           this.cityList = item.city
    //           this.$set(this.orgInfo, 'cityCode', this.cityList[0].code)
    //           this.$set(this.orgInfo, 'cityName', this.cityList[0].name)
    //         } else {
    //           this.$set(this.orgInfo, 'cityCode', '')
    //           this.$set(this.orgInfo, 'cityName', '')
    //         }
    //         this.$set(this.orgInfo, 'provinceName', item.name)
    //       }
    //     })
    //   }
    // }
    // 'orgInfo.organType': {
    //   handler (val) {
    //     if (val) {
    //       if (val === 'CITY') {
    //         if () {
    //           this.regions.forEach(item => {
    //             if (item.code === Number(val)) {
    //               this.cityList = item.city
    //               // this.orgInfo.cityCode = this.cityList[0].code
    //               this.$set(this.orgInfo, 'cityCode', this.cityList[0].code)
    //               this.$set(this.orgInfo, 'cityName', this.cityList[0].name)
    //               // this.$set(this.orgInfo, 'provinceName', item.name)
    //             }
    //           })
    //         }
    //       } else {
    //         this.cityList = []
    //         this.$set(this.orgInfo, 'cityCode', '')
    //         this.$set(this.orgInfo, 'cityName', '')
    //       }
    //     }
    //   }
    // }
  },
  created () {
    const { page, cityCode, provinceCode,countyCode, keyWord } = this.$route.query
    page && (this.page = Number(page))
    cityCode && (this.$set(this.selectVal, 'cityCode', cityCode))
    provinceCode && (this.$set(this.selectVal, 'provinceCode', provinceCode))
    countyCode && (this.$set(this.selectVal, 'countyCode', countyCode))
    keyWord && (this.$set(this.selectVal, 'keyWord', keyWord))
    provinceCode && this.setCityList()
    this.getOrganList()
  },
  methods: {
    changeType (val) {
      // if (val === 'CITY') {
      //   if (this.orgInfo.provinceCode) {
      //     this.regions.forEach(item => {
      //       if (item.code === this.orgInfo.provinceCode) {
      //         this.cityList = item.city
      //         // this.orgInfo.cityCode = this.cityList[0].code
      //         this.$set(this.orgInfo, 'cityCode', this.cityList[0].code)
      //         this.$set(this.orgInfo, 'cityName', this.cityList[0].name)
      //       }
      //     })
      //   }
      // } else {
      //   this.cityList = []
      //   this.$set(this.orgInfo, 'cityCode', '')
      //   this.$set(this.orgInfo, 'cityName', '')
      // }
      if(val === 'CITY') {
        if(this.select_city_list.length) {
          const { code, name } = this.select_city_list[0];
          this.orgInfo = Object.assign({}, this.orgInfo, {
            cityCode: code,
            cityName: name,
          })
        }
      } else if( val === 'COUNTY') {
          // const { code, name } = this.select_city_list[0];
      } else {
      }
    },
    getOrganList () {
      this.loading = true
      this.empty = false
      this.showList = false
      org.getOrganList({ page: this.page, size: this.pageSize, cityCode: this.selectVal.cityCode, provinceCode: this.selectVal.provinceCode, countyCode: this.selectVal.countyCode, keyWord: this.selectVal.keyWord }).then((res) => {
        this.loading = false
        let data = res.content
        this.total = res.totalElements
        if (data.length) {
          this.orgList = data
          this.showList = true
        } else {
          this.empty = true
        }
      }).catch((err) => {
        this.loading = false
        console.error(err)
      })
    },
    addOrgan () {
      this.$refs['orgInfo'].validate(async valid => {
        if (valid) {
          this.addbtnLoading = true
          let requestName = org.addOrgan
          let requestData = {
            guoziOrgan: {
              // provinceCode: this.orgInfo.provinceCode,
              // provinceName: this.orgInfo.provinceName,
              provinceCode: '31',
              provinceName: '上海市', // 避免麻烦，写死
              cityCode: this.orgInfo.cityCode,
              countyCode: this.orgInfo.countyCode,
              countyName: this.orgInfo.countyName,
              cityName: this.orgInfo.cityName,
              organName: this.orgInfo.organName,
              organShortName: this.orgInfo.organShortName,
              organType: this.orgInfo.organType,
              banner: this.orgInfo.banner
            },
            userForm: {
              phone: this.orgInfo.phone,
              idName: this.orgInfo.idName,
              loginName: this.orgInfo.loginName + (this.isEdit ? '' : 'admin')
            }
          }
          if (this.isEdit) {
            requestName = org.updateOrg
            requestData.guoziOrgan.status = this.orgInfo.status
            if (this.orgInfo.password) {
              let username = this.orgInfo.loginName
              // // ras 加密
              let publicKey = await auth.getPublicKey(username)
              let encryptor = new JSEncrypt()
              encryptor.setPublicKey(publicKey)
              let rsaPassword = encryptor.encrypt(this.orgInfo.password)
              requestData.userForm.password = rsaPassword
            }
            requestData.guoziOrgan.id = this.orgInfo.id
          }
          if(!requestData.cityName) requestData.guoziOrgan.cityName = this.defaultProvinceName;
          requestName(requestData).then(res => {
            this.addbtnLoading = false
            if (res.code) {
              // if (res.code === 'PhoneRepeat') {
              //   this.PhoneRepeat = true
              //   this.$refs['orgInfo'].validateField('phone')
              // }
              // if (res.code === 'loginNameRepeat') {
              //   this.IdNumberRepeat = true
              //   this.$refs['orgInfo'].validateField('loginName')
              // }
              this.$message.error(res.msg)
            } else {
              this.getOrganList()
              this.addOrg = false
            }
          }).catch(err => {
            this.addbtnLoading = false
            console.error(err)
          })
        }
      })
    },
    editOrg (uuid) {
      if (this.editIng) return
      this.editIng = true
      org.getOrgInfo(uuid).then((res) => {
        const { idName, loginName, phone } = res.user
        const { cityName, cityCode, organType, provinceName, provinceCode, countyCode, organName, organShortName, status, id, banner } = res.organ
        this.orgInfo = {
          idName,
          cityName,
          id,
          countyCode: countyCode === 0 ? '' : String(countyCode),
          cityCode: cityCode === 0 ? '' : String(cityCode),
          provinceName,
          organType,
          provinceCode: provinceCode === 0 ? '' : String(provinceCode),
          organName,
          phone,
          loginName,
          organShortName,
          status,
          banner: banner || ''
        }
        this.addOrg = true
        this.isEdit = true
        this.editIng = false
      }).catch((err) => {
        this.editIng = false
        console.log(err)
      })
    },
    goInfo (uuid) {
      this.$router.push({
        path: 'info',
        query: {
          uuid
        }
      })
    },
    // changeCity () {
    //   this.orgInfo.cityName = this.cityList.find(item => {
    //     return item.code === this.orgInfo.cityCode
    //   }).name
    // },
    changeCountyForCoachList() {
      if(this.selectVal.countyCode) {
        this.orgInfo.countyName = this.sh_county_list.find(item => {
          return item.code === this.selectVal.countyCode
        }).name || '';
      } else {
        this.orgInfo.countyName = '';
      }

      this.changeQuery(true);
    },
    changeQuery (flag) {
      if (flag) this.page = 0
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: this.page,
          cityCode: this.selectVal.cityCode,
          countyCode: this.selectVal.countyCode,
          provinceCode: this.selectVal.provinceCode,
          keyWord: this.selectVal.keyWord
        }
      })
      this.getOrganList()
    },
    changeProvince () {
      if (this.selectVal.provinceCode) {
        this.selectRegions.forEach(item => {
          if (item.code === this.selectVal.provinceCode) {
            this.selectCityList = item.city
            this.$set(this.selectVal, 'cityCode', '')
          }
        })
      } else {
        this.selectCityList = []
        this.$set(this.selectVal, 'cityCode', '')
      }
      // this.getOrganList()
      this.changeQuery(true)
    },
    setCityList () {
      this.selectRegions.forEach(item => {
        if (item.code === this.selectVal.provinceCode) {
          this.selectCityList = item.city
          // this.selectVal.cityCode = this.selectCityList[0].code
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .list_wrap
    flex 1
    overflow hidden
    .table {
      display flex
      flex-direction column
      flex 1
      width: 100%;
      // margin: 30px 0 0;
      .thead, .tbody {
        border: 1px solid $color_white;
      }
      .thead {
        margin: 0 40px;
        .tr {
          height: 45px;
          display: flex;
        }
      }
      .scrollArea {
        height: 425px;
        padding-bottom 15px
        /*flex 1 */
        /*overflow hidden*/
      }
      .tbodyWrap {
        display block
        // padding: 0 40px;
      }
      .tbody {
        display block
        width 810px
        margin-left auto
        margin-right auto
        max-width: 810px;
        border-top: none;
        border-bottom: none;
        .tr {
          height: 49px;
          display: flex;
          border-bottom: 1px solid $color_white;
        }
      }
      .th, .td {
        height: 100%;
        /*flex: 1 1 auto;*/
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: $font_size_medium;
        border-right: 1px solid $color_white;
      }
      .th:last-child, .td:last-child {
        border-right: none;
      }
      .td {
        p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: $color_white;
        }
      }
      .seq {
        width 7%
      }
      .name{
        width 18%
      }
      .idName{
        width: 18%;
      }
      .province,.city,.county{
        width: 16%;
      }
      .telNumber{
        width:20%;
      }
      .status{
        width 12.5%
      }
      .opt{
        width: 12.5%;
        p{
          width 100%
          text-align center
          .item{
            cursor: pointer;
            user-select: none;
            color $green_color
          }
          .split{
            margin 0 5px
          }
        }
      }
    }
  .tip
    margin-top 10px
    color red
    width 100%
    text-align center
    word-break break-word
.w_select
  width 125px !important

</style>

<style lang="stylus">
  .provinceOrg
    display flex
    .label
      width: 180px;
      height 40px
      line-height 40px
      text-align center
      &:before
        content: '*';
        color: #F56C6C;
        margin-right: 4px;
</style>
